// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardRightSectionContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.liveContainer {
  width: 100%;
  background-color: #0e1b1b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 7.5px;
  gap: 10px;
  padding-top: 19px;
  padding-bottom: 19px;
}

.liveTextContainer {
  display: flex;
  align-items: center;
  gap: 5px;
}

.liveText {
  font-family: "Satoshi", sans-serif;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.735px;
}

.liveNumbersText {
  font-family: "Satoshi", sans-serif;
  text-align: center;
  font-size: 38px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.redDot {
  width: 5px;
  height: 5px;
}

.groupProfilePic {
  height: 36.6px;
  width: 126px;
}

.downloadAppContainer {
  position: relative;
  border-radius: 7.5px;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  background: linear-gradient(90deg,
      rgba(72, 209, 204, 0.5) 0%,
      rgba(30, 144, 255, 0.5) 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-family: "Inter", sans-serif;
  overflow: visible;
}

.downloadAppText {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}

.smallTextContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.downloadAppText2 {
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.recentVoteContainer {
  width: 100%;
  background-color: #0e1b1b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 7.5px;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  padding-bottom: 15px;
}

.recentVoteText {
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: "Satoshi", sans-serif;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.735px;
  text-transform: capitalize;
}

.recentVoteCardContainer {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding: 18px 16px;
  margin-top: 5px;
}

.recentVoteCardHeaderContainer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.headerProfilePic,
.recentVoteProfilePic {
  height: 36px;
  width: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.recentVoteProfilePic {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.recentVoteCardHeaderTextContainer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.recentVoteCardHeaderText1 {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.recentVoteCardHeaderText2 {
  color: #777;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.recentVoteTitleContainer {
  margin-top: 8px;
}

.recentVoteTitleText {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 2.6em; /* Stable space for up to 2 lines of title */
}

.recentVoteCardActions {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 15px;
  margin-top: 3vh;
}

.recentVoteCardActionContainer {
  display: flex;
  align-items: center;
  gap: 6px;
}

.feedCardFooterIcon {
  width: 25px;
  height: 25px;
}

@media (max-width: 1640px) {
  .dashboardRightSectionContainer {
    gap: 30px;
  }

  .downloadAppText {
    font-size: 22px;
  }

  .downloadAppText2 {
    font-size: 10px;
  }

  .recentVoteContainer {
    border-radius: 7px;
    border: 1.5px solid rgba(255, 255, 255, 0.07);
    padding-bottom: 10px;
  }

  .recentVoteText {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
  }

  .recentVoteCardContainer {
    padding: 10px 10px;
  }

  .recentVoteCardHeaderContainer {
    gap: 8px;
  }

  .headerProfilePic,
  .recentVoteProfilePic {
    height: 40px;
    width: 40px;
  }
  .recentVoteProfilePic {
    font-size: 15px;
  }

  .recentVoteCardHeaderText1 {
    font-size: 14px;
  }

  .recentVoteTitleContainer {
    margin-top: 10px;
  }

  .recentVoteTitleText {
    font-size: 16px;
  }

  .recentVoteCardActions {
    gap: 12px;
    margin-top: 2vh;
  }

  .feedCardFooterIcon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 1440px) {
  .dashboardRightSectionContainer {
    gap: 20px;
  }

  .downloadAppText {
    font-size: 20px;
  }

  .downloadAppText2 {
    font-size: 9px;
  }

  .recentVoteText {
    padding-top: 10px;
    padding-bottom: 0px;
    font-size: 16px;
  }

  .recentVoteCardContainer {
    padding: 8px 8px;
  }

  .recentVoteCardHeaderContainer {
    gap: 6px;
  }

  .headerProfilePic,
  .recentVoteProfilePic {
    height: 35px;
    width: 35px;
  }
  .recentVoteProfilePic {
    font-size: 13px;
  }

  .recentVoteCardHeaderText1 {
    font-size: 12px;
  }

  .recentVoteTitleContainer {
    margin-top: 8px;
  }

  .recentVoteTitleText {
    font-size: 14px;
  }

  .recentVoteCardActions {
    gap: 10px;
    margin-top: 1vh;
  }

  .feedCardFooterIcon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 1280px) {
  .dashboardRightSectionContainer {
    gap: 10px;
  }

  .downloadAppText {
    font-size: 18px;
  }

  .downloadAppText2 {
    font-size: 8px;
  }

  .recentVoteText {
    padding-top: 8px;
    padding-bottom: 0px;
    font-size: 14px;
  }

  .recentVoteCardContainer {
    padding: 6px 6px;
  }

  .recentVoteCardHeaderContainer {
    gap: 4px;
  }

  .headerProfilePic,
  .recentVoteProfilePic {
    height: 30px;
    width: 30px;
  }
  .recentVoteProfilePic {
    font-size: 11px;
  }

  .recentVoteCardHeaderText1 {
    font-size: 10px;
  }

  .recentVoteTitleContainer {
    margin-top: 6px;
  }

  .recentVoteTitleText {
    font-size: 12px;
  }

  .recentVoteCardActions {
    gap: 8px;
    margin-top: 0.5vh;
  }

  .feedCardFooterIcon {
    width: 15px;
    height: 15px;
  }
  .recentVoteCardActions .feedCardFooterText {
    font-size: 9px !important;
  }
}

@media (max-width: 1024px) {
  .dashboardRightSectionContainer {
    gap: 5px;
  }

  .downloadAppText {
    font-size: 16px;
  }

  .downloadAppText2 {
    font-size: 7px;
  }

  .recentVoteText {
    padding-top: 5px;
    padding-bottom: 0px;
    font-size: 12px;
  }

  .recentVoteCardContainer {
    padding: 4px 4px;
  }

  .recentVoteCardHeaderContainer {
    gap: 4px;
  }

  .headerProfilePic,
  .recentVoteProfilePic {
    height: 25px;
    width: 25px;
  }
  .recentVoteProfilePic {
    font-size: 9px;
  }

  .recentVoteCardHeaderText1 {
    font-size: 10px;
  }

  .recentVoteTitleContainer {
    margin-top: 4px;
  }

  .recentVoteTitleText {
    font-size: 11px;
  }

  .feedCardFooterIcon {
    width: 15px;
    height: 15px;
  }
}

/* =====================================================================
   INTERACTIVE RECENT VOTES
   ===================================================================== */
.recentVoteOptionsScrollable {
  height: 165px; /* Increased stable height */
  overflow-y: auto;
  margin-top: 8px;
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.recentVoteOptionsScrollable::-webkit-scrollbar {
  width: 3px;
}

.recentVoteOptionsScrollable::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.recentVoteOptionsScrollable::-webkit-scrollbar-thumb {
  background: rgba(90, 175, 154, 0.75);
  border-radius: 4px;
}

.recentVoteOptionsScrollable::-webkit-scrollbar-thumb:hover {
  background: rgba(90, 175, 154, 0.95);
}

.recentVoteActionButtons {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.recentVoteOptionBtn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #fff;
  min-height: 28px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Inter", sans-serif;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
}

.recentVoteOptionBtn:hover:not(:disabled) {
  background: rgba(90, 175, 154, 0.12);
  border-color: #5AAF9A;
  color: #5AAF9A;
}

.recentVoteOptionBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.recentVoteResults {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.recentVoteProgressWrapper {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  min-height: 28px;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
}

.recentVoteProgressBar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgba(90, 175, 154, 0.22);
  border-right: 1px solid rgba(90, 175, 154, 0.4);
  transition: width 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1;
}

.recentVoteProgressContent {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  font-family: "Inter", sans-serif;
  font-size: 11.5px;
  color: #fff;
}

.optionValueText {
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  padding-right: 8px;
}

.optionPercentText {
  font-weight: 700;
  color: #5AAF9A;
}

.changeVoteBtnContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.changeVoteBtn {
  background: none;
  border: none;
  color: #5AAF9A;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 4px;
  font-family: "Inter", sans-serif;
  text-decoration: underline;
  transition: opacity 0.2s;
  outline: none;
}

.changeVoteBtn:hover {
  opacity: 0.8;
}

/* Card Footer with actions & switcher */
.recentVoteCardFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 10px;
}

.recentVoteCardActions {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 0 !important; /* reset margin from list card actions styling */
}

.recentVoteCardActions .feedCardFooterText {
  font-size: 11px !important;
  font-family: "Inter", sans-serif;
  color: rgba(255, 255, 255, 0.7);
}

.recentVoteSwitcher {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 20px;
  padding: 3px 10px;
}

.switcherBtn {
  background: none;
  border: none;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  padding: 0 4px;
  transition: all 0.2s;
  outline: none;
}

.switcherBtn:hover:not(:disabled) {
  color: #5AAF9A;
  transform: scale(1.2);
}

.switcherBtn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.switcherText {
  color: #777;
  font-family: "Inter", sans-serif;
  font-size: 11.5px;
  font-weight: 600;
  min-width: 32px;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
}

@media (max-width: 1640px) {
  .recentVoteOptionBtn {
    min-height: 24px;
    padding: 4px 10px;
    font-size: 11.5px;
  }
  .recentVoteProgressWrapper {
    min-height: 24px;
  }
  .recentVoteProgressContent {
    font-size: 11px;
    padding: 4px 6px;
  }
  .recentVoteSwitcher {
    padding: 2px 8px;
  }
  .switcherBtn {
    font-size: 11px;
  }
  .switcherText {
    font-size: 10px;
    min-width: 28px;
  }
  .recentVoteOptionsScrollable {
    height: 140px;
  }
  .recentVoteCardActions .feedCardFooterText {
    font-size: 10px !important;
  }
}

/* Scroll and Hover Reset Vote Button Styles */

.optionPercentOrChange {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 40px;
  height: 100%;
}



/* Highlight Selected Voted Option */
.recentVoteProgressWrapper.selected {
  border-color: rgba(90, 175, 154, 0.5);
  background: rgba(90, 175, 154, 0.05);
}

.recentVoteProgressWrapper.selected .recentVoteProgressBar {
  background: rgba(90, 175, 154, 0.35);
  border-right: 1.5px solid #5AAF9A;
}

.recentVoteProgressWrapper.selected .optionPercentText {
  color: #5AAF9A;
  font-weight: 800;
}

/* ==================== Download App Card Overrides ==================== */
.downloadAppCards {
  margin-top: 15px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.downloadAppCardContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.downloadAppContainer .downloadAppCard {
  background-color: #ffffff;
  border-radius: 8px;
  height: 48px;
  flex: 1 1;
  max-width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.downloadAppContainer .downloadAppCard:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.downloadAppContainer .downloadAppCardIcon {
  height: 24px;
  width: 24px;
  flex-shrink: 0;
}

.downloadAppContainer .downloadAppCardIcon2 {
  height: 24px;
  width: 24px;
  flex-shrink: 0;
}

.downloadAppContainer .downloadAppCardTextContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 6px;
  line-height: 1.2;
}

.downloadAppContainer .downloadAppCardText1 {
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.downloadAppContainer .downloadAppCardText2 {
  color: #111111;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/Components/DashboardRightSection/DashboardRightSection.css"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C;;mCAEiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,aAAa,EAAE,4CAA4C;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6CAA6C;IAC7C,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;0EAE0E;AAC1E;EACE,aAAa,EAAE,4BAA4B;EAC3C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,oCAAoC;EACpC,+CAA+C;EAC/C,oDAAoD;EACpD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB,EAAE,gDAAgD;AAC5E;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;;AAE9C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;;;AAIA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["@import url(\"https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n\n.dashboardRightSectionContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n}\n\n.liveContainer {\n  width: 100%;\n  background-color: #0e1b1b;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 7.5px;\n  gap: 10px;\n  padding-top: 19px;\n  padding-bottom: 19px;\n}\n\n.liveTextContainer {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.liveText {\n  font-family: \"Satoshi\", sans-serif;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 23.735px;\n}\n\n.liveNumbersText {\n  font-family: \"Satoshi\", sans-serif;\n  text-align: center;\n  font-size: 38px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.redDot {\n  width: 5px;\n  height: 5px;\n}\n\n.groupProfilePic {\n  height: 36.6px;\n  width: 126px;\n}\n\n.downloadAppContainer {\n  position: relative;\n  border-radius: 7.5px;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  background: linear-gradient(90deg,\n      rgba(72, 209, 204, 0.5) 0%,\n      rgba(30, 144, 255, 0.5) 100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  font-family: \"Inter\", sans-serif;\n  overflow: visible;\n}\n\n.downloadAppText {\n  text-align: center;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n}\n\n.smallTextContainer {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.downloadAppText2 {\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.recentVoteContainer {\n  width: 100%;\n  background-color: #0e1b1b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border-radius: 7.5px;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  padding-bottom: 15px;\n}\n\n.recentVoteText {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-family: \"Satoshi\", sans-serif;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 23.735px;\n  text-transform: capitalize;\n}\n\n.recentVoteCardContainer {\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.1);\n  box-sizing: border-box;\n  padding: 18px 16px;\n  margin-top: 5px;\n}\n\n.recentVoteCardHeaderContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.headerProfilePic,\n.recentVoteProfilePic {\n  height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  object-fit: cover;\n}\n\n.recentVoteProfilePic {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n\n.recentVoteCardHeaderTextContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.recentVoteCardHeaderText1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.recentVoteCardHeaderText2 {\n  color: #777;\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.recentVoteTitleContainer {\n  margin-top: 8px;\n}\n\n.recentVoteTitleText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 2.6em; /* Stable space for up to 2 lines of title */\n}\n\n.recentVoteCardActions {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 15px;\n  margin-top: 3vh;\n}\n\n.recentVoteCardActionContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.feedCardFooterIcon {\n  width: 25px;\n  height: 25px;\n}\n\n@media (max-width: 1640px) {\n  .dashboardRightSectionContainer {\n    gap: 30px;\n  }\n\n  .downloadAppText {\n    font-size: 22px;\n  }\n\n  .downloadAppText2 {\n    font-size: 10px;\n  }\n\n  .recentVoteContainer {\n    border-radius: 7px;\n    border: 1.5px solid rgba(255, 255, 255, 0.07);\n    padding-bottom: 10px;\n  }\n\n  .recentVoteText {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    font-size: 18px;\n  }\n\n  .recentVoteCardContainer {\n    padding: 10px 10px;\n  }\n\n  .recentVoteCardHeaderContainer {\n    gap: 8px;\n  }\n\n  .headerProfilePic,\n  .recentVoteProfilePic {\n    height: 40px;\n    width: 40px;\n  }\n  .recentVoteProfilePic {\n    font-size: 15px;\n  }\n\n  .recentVoteCardHeaderText1 {\n    font-size: 14px;\n  }\n\n  .recentVoteTitleContainer {\n    margin-top: 10px;\n  }\n\n  .recentVoteTitleText {\n    font-size: 16px;\n  }\n\n  .recentVoteCardActions {\n    gap: 12px;\n    margin-top: 2vh;\n  }\n\n  .feedCardFooterIcon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .dashboardRightSectionContainer {\n    gap: 20px;\n  }\n\n  .downloadAppText {\n    font-size: 20px;\n  }\n\n  .downloadAppText2 {\n    font-size: 9px;\n  }\n\n  .recentVoteText {\n    padding-top: 10px;\n    padding-bottom: 0px;\n    font-size: 16px;\n  }\n\n  .recentVoteCardContainer {\n    padding: 8px 8px;\n  }\n\n  .recentVoteCardHeaderContainer {\n    gap: 6px;\n  }\n\n  .headerProfilePic,\n  .recentVoteProfilePic {\n    height: 35px;\n    width: 35px;\n  }\n  .recentVoteProfilePic {\n    font-size: 13px;\n  }\n\n  .recentVoteCardHeaderText1 {\n    font-size: 12px;\n  }\n\n  .recentVoteTitleContainer {\n    margin-top: 8px;\n  }\n\n  .recentVoteTitleText {\n    font-size: 14px;\n  }\n\n  .recentVoteCardActions {\n    gap: 10px;\n    margin-top: 1vh;\n  }\n\n  .feedCardFooterIcon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .dashboardRightSectionContainer {\n    gap: 10px;\n  }\n\n  .downloadAppText {\n    font-size: 18px;\n  }\n\n  .downloadAppText2 {\n    font-size: 8px;\n  }\n\n  .recentVoteText {\n    padding-top: 8px;\n    padding-bottom: 0px;\n    font-size: 14px;\n  }\n\n  .recentVoteCardContainer {\n    padding: 6px 6px;\n  }\n\n  .recentVoteCardHeaderContainer {\n    gap: 4px;\n  }\n\n  .headerProfilePic,\n  .recentVoteProfilePic {\n    height: 30px;\n    width: 30px;\n  }\n  .recentVoteProfilePic {\n    font-size: 11px;\n  }\n\n  .recentVoteCardHeaderText1 {\n    font-size: 10px;\n  }\n\n  .recentVoteTitleContainer {\n    margin-top: 6px;\n  }\n\n  .recentVoteTitleText {\n    font-size: 12px;\n  }\n\n  .recentVoteCardActions {\n    gap: 8px;\n    margin-top: 0.5vh;\n  }\n\n  .feedCardFooterIcon {\n    width: 15px;\n    height: 15px;\n  }\n  .recentVoteCardActions .feedCardFooterText {\n    font-size: 9px !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .dashboardRightSectionContainer {\n    gap: 5px;\n  }\n\n  .downloadAppText {\n    font-size: 16px;\n  }\n\n  .downloadAppText2 {\n    font-size: 7px;\n  }\n\n  .recentVoteText {\n    padding-top: 5px;\n    padding-bottom: 0px;\n    font-size: 12px;\n  }\n\n  .recentVoteCardContainer {\n    padding: 4px 4px;\n  }\n\n  .recentVoteCardHeaderContainer {\n    gap: 4px;\n  }\n\n  .headerProfilePic,\n  .recentVoteProfilePic {\n    height: 25px;\n    width: 25px;\n  }\n  .recentVoteProfilePic {\n    font-size: 9px;\n  }\n\n  .recentVoteCardHeaderText1 {\n    font-size: 10px;\n  }\n\n  .recentVoteTitleContainer {\n    margin-top: 4px;\n  }\n\n  .recentVoteTitleText {\n    font-size: 11px;\n  }\n\n  .feedCardFooterIcon {\n    width: 15px;\n    height: 15px;\n  }\n}\n\n/* =====================================================================\n   INTERACTIVE RECENT VOTES\n   ===================================================================== */\n.recentVoteOptionsScrollable {\n  height: 165px; /* Increased stable height */\n  overflow-y: auto;\n  margin-top: 8px;\n  padding-right: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.recentVoteOptionsScrollable::-webkit-scrollbar {\n  width: 3px;\n}\n\n.recentVoteOptionsScrollable::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 4px;\n}\n\n.recentVoteOptionsScrollable::-webkit-scrollbar-thumb {\n  background: rgba(90, 175, 154, 0.75);\n  border-radius: 4px;\n}\n\n.recentVoteOptionsScrollable::-webkit-scrollbar-thumb:hover {\n  background: rgba(90, 175, 154, 0.95);\n}\n\n.recentVoteActionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.recentVoteOptionBtn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  color: #fff;\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: \"Inter\", sans-serif;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.recentVoteOptionBtn:hover:not(:disabled) {\n  background: rgba(90, 175, 154, 0.12);\n  border-color: #5AAF9A;\n  color: #5AAF9A;\n}\n\n.recentVoteOptionBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.recentVoteResults {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.recentVoteProgressWrapper {\n  position: relative;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 6px;\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.recentVoteProgressBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(90, 175, 154, 0.22);\n  border-right: 1px solid rgba(90, 175, 154, 0.4);\n  transition: width 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 1;\n}\n\n.recentVoteProgressContent {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 10px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 11.5px;\n  color: #fff;\n}\n\n.optionValueText {\n  font-weight: 500;\n  white-space: normal;\n  word-break: break-word;\n  padding-right: 8px;\n}\n\n.optionPercentText {\n  font-weight: 700;\n  color: #5AAF9A;\n}\n\n.changeVoteBtnContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.changeVoteBtn {\n  background: none;\n  border: none;\n  color: #5AAF9A;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 2px 4px;\n  font-family: \"Inter\", sans-serif;\n  text-decoration: underline;\n  transition: opacity 0.2s;\n  outline: none;\n}\n\n.changeVoteBtn:hover {\n  opacity: 0.8;\n}\n\n/* Card Footer with actions & switcher */\n.recentVoteCardFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n  width: 100%;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 10px;\n}\n\n.recentVoteCardActions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 0 !important; /* reset margin from list card actions styling */\n}\n\n.recentVoteCardActions .feedCardFooterText {\n  font-size: 11px !important;\n  font-family: \"Inter\", sans-serif;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.recentVoteSwitcher {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 20px;\n  padding: 3px 10px;\n}\n\n.switcherBtn {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0 4px;\n  transition: all 0.2s;\n  outline: none;\n}\n\n.switcherBtn:hover:not(:disabled) {\n  color: #5AAF9A;\n  transform: scale(1.2);\n}\n\n.switcherBtn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.switcherText {\n  color: #777;\n  font-family: \"Inter\", sans-serif;\n  font-size: 11.5px;\n  font-weight: 600;\n  min-width: 32px;\n  text-align: center;\n  user-select: none;\n}\n\n@media (max-width: 1640px) {\n  .recentVoteOptionBtn {\n    min-height: 24px;\n    padding: 4px 10px;\n    font-size: 11.5px;\n  }\n  .recentVoteProgressWrapper {\n    min-height: 24px;\n  }\n  .recentVoteProgressContent {\n    font-size: 11px;\n    padding: 4px 6px;\n  }\n  .recentVoteSwitcher {\n    padding: 2px 8px;\n  }\n  .switcherBtn {\n    font-size: 11px;\n  }\n  .switcherText {\n    font-size: 10px;\n    min-width: 28px;\n  }\n  .recentVoteOptionsScrollable {\n    height: 140px;\n  }\n  .recentVoteCardActions .feedCardFooterText {\n    font-size: 10px !important;\n  }\n}\n\n/* Scroll and Hover Reset Vote Button Styles */\n\n.optionPercentOrChange {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 40px;\n  height: 100%;\n}\n\n\n\n/* Highlight Selected Voted Option */\n.recentVoteProgressWrapper.selected {\n  border-color: rgba(90, 175, 154, 0.5);\n  background: rgba(90, 175, 154, 0.05);\n}\n\n.recentVoteProgressWrapper.selected .recentVoteProgressBar {\n  background: rgba(90, 175, 154, 0.35);\n  border-right: 1.5px solid #5AAF9A;\n}\n\n.recentVoteProgressWrapper.selected .optionPercentText {\n  color: #5AAF9A;\n  font-weight: 800;\n}\n\n/* ==================== Download App Card Overrides ==================== */\n.downloadAppCards {\n  margin-top: 15px;\n  width: 100%;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.downloadAppCardContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.downloadAppContainer .downloadAppCard {\n  background-color: #ffffff;\n  border-radius: 8px;\n  height: 48px;\n  flex: 1;\n  max-width: 130px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.downloadAppContainer .downloadAppCard:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.downloadAppContainer .downloadAppCardIcon {\n  height: 24px;\n  width: 24px;\n  flex-shrink: 0;\n}\n\n.downloadAppContainer .downloadAppCardIcon2 {\n  height: 24px;\n  width: 24px;\n  flex-shrink: 0;\n}\n\n.downloadAppContainer .downloadAppCardTextContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 6px;\n  line-height: 1.2;\n}\n\n.downloadAppContainer .downloadAppCardText1 {\n  color: #333333;\n  font-family: \"Inter\", sans-serif;\n  font-size: 8px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.downloadAppContainer .downloadAppCardText2 {\n  color: #111111;\n  font-family: \"Inter\", sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
